<template>
  <div class="message-container">
    <el-badge :value="unReadMessageCount" class="item" size="small" :max='999'>
      <i @click="openMessageBox" class="HSIconfont hs-icon-notification"></i>
    </el-badge>
    <my-message-box
      v-if="drawer.visible"
      v-model="drawer.visible"
      :drawer="drawer"
    ></my-message-box>
    <message-content v-model="messageShow"></message-content>
  </div>
</template>

<script>
import MyMessageBox from "./MessageDrawer.vue";
import MessageContent from "./MessageContent.vue";
import { initState as globalState } from "@/store/shardActions";
import { isEmpty } from "@/utils/utils";
import { closeAllMessage ,closeMessage} from "@/common/noticeTip";

export default {
  components: {
    MyMessageBox,
    MessageContent,
  },
  watch: {
    language() {
      this.languageChange = true;
      if (this.messageList.length) {
        this.changeMessageListLang();
      }else{
        this.languageChange = false;
      }
    },
    "$store.state.config.inboxDetailDialog.show"(v) {
      this.messageShow = v;
    },

    "$store.state.wsStore.messageData"(v) {
      this.dealMessageNotice(v);
    },
  },

  computed: {
    language() {
      return globalState.currentLanguage;
    },
    unReadMessageCount() {
      return this.$store.state.wsStore.count == 0
        ? null
        : this.$store.state.wsStore.count;
    },
  },

  data() {
    return {
      drawer: {
        visible: false,
        data: {},
      },
      messageShow: false,
      wsMessageCache: "",
      changeLanguageMessage: null,
      languageChange: false,
      messageList: [],
    };
  },

  methods: {
    openMessageBox() {
      this.drawer.visible = true;
    },

    dealMessageNotice(data) {
      let message = "";
      switch (data.type) {
        case "NORMAL_NOTICE":
        case "IMPORTANT_NOTICE":
        case "WARNING_NOTICE":
          this.createdMessage(data);
          break;

        case "TERMINAL_SUBSCRIBE":
        case "TERMINAL_ENABLE":
          this.$store.commit("config/dataUpdate", "baseInfo");
          break;

        case "LOGOUT_BY_PLUGIN_REMOVE":
          this.$confirm(
            this.$t("logoutBoxPromptMessage.logoutByPluginRemove"),
            "",
            {
              confirmButtonText: this.$t("button.exitImmediately"),
              cancelButtonText: this.$t("button.exitLater"),
              type: "warning",
              closeOnClickModal: false,
              closeOnPressEscape: false,
              showClose: false,
            }
          ).then(() => {
            this.$store.dispatch("config/logout");
          });
          break;

        case "LOGOUT_BY_REMOTE_LOGIN":
          if (data.pluginId == globalState.accessToken) {
            return;
          }
          this.$confirm(
            this.$t("logoutBoxPromptMessage.logoutByRemoteLogin"),
            "",
            {
              showCancelButton: false,
              confirmButtonText: this.$t("button.confirm"),
              // showConfirmButton:false,
              type: "warning",
              closeOnClickModal: false,
              closeOnPressEscape: false,
              showClose: false,
            }
          ).then(() => {
            this.$store.dispatch("config/logout");
          });
          break;
        case "REFRESH_BY_PLUGIN_UNINSTALL":
        case "REFRESH_BY_ROLE_PERMISSION_CHANGE":
        case "REFRESH_BY_USER_ROLE_CHANGE":
          message = "logoutBoxPromptMessage.refreshByPluginUninstall";
          if (data.type == "REFRESH_BY_ROLE_PERMISSION_CHANGE") {
            message = "logoutBoxPromptMessage.refreshByRolePermissionChange";
          } else if (data.type == "REFRESH_BY_USER_ROLE_CHANGE") {
            message = "logoutBoxPromptMessage.refreshByUserRoleChange";
          }
          this.$confirm(this.$t(message), "", {
            showCancelButton: false,
            confirmButtonText: this.$t("button.refreshImmediately"),
            type: "warning",
            closeOnClickModal: false,
            closeOnPressEscape: false,
            showClose: false,
          }).then(() => {
            // this.$router.push({ name: "welcome" });
            // location.reload();
            // 重定向至登录页面
            let currentUrl = window.location.href;
            let position = currentUrl.indexOf("/#");
            let welcomeUrl = currentUrl.substring(0, position)+'/#/as/welcome';
            window.location.href = welcomeUrl;
            location.reload();
          });
          break;

        case "LOGOUT_BY_PLUGIN_INSTALL":
        case "LOGOUT_BY_APP_REGISTER":
          message = "logoutBoxPromptMessage.logoutByPluginInstall";
          if (data.type == "LOGOUT_BY_APP_REGISTER") {
            message = "logoutBoxPromptMessage.logoutByAppPermissionRegister";
          }
          this.$confirm(this.$t(message), "", {
            confirmButtonText: this.$t("button.exitImmediately"),
            cancelButtonText: this.$t("button.exitLater"),
            type: "warning",
            closeOnClickModal: false,
            closeOnPressEscape: false,
            showClose: false,
          }).then(() => {
            this.$store.dispatch("config/logout");
          });
          break;

        default:
          break;
      }
    },

    async createdMessage(messageInfo) {
      let msgId = `${messageInfo.noticeId}@${messageInfo.taskId}`;
      if (this.wsMessageCache != msgId) {
        this.wsMessageCache = `${messageInfo.noticeId}@${messageInfo.taskId}`;
      } else if (!this.languageChange) {
        return;
      }
      if (
        !this.messageList.some((item) => item.msgId == msgId)
      ) {
        this.messageList.push({ msgId, messageInfo });
      }

      let title = messageInfo.data[this.language] || messageInfo.data["en"];
      const h = this.$createElement;
      let type = "default";
      let duration = 0;
      switch (messageInfo.type) {
        case "IMPORTANT_NOTICE":
          type = "important";
          break;

        case "WARNING_NOTICE":
          type = "warning";
          break;

        default:
          duration = 5000;
          type;
      }
      let instance = null;
      let messageContent = h("div", { class: "global-message-container" }, [
        h("span", { class: "global-message-iconbox" }, [
          h("i", { class: "HSIconfont hs-icon-notification1" }),
        ]),
        h("p", { class: "message-title" }, title),
        h(
          "el-button",
          {
            props: {
              plain: true,
              size: "mini",
            },
            class: "message-detail-btn",
            on: {
              click: () => this.readMessage(msgId, instance),
            },
          },
          this.$t("messageBox.getDetails")
        ),
      ]);
      instance = await this.$createNotice(messageContent, {}, type, {
        duration,
        offset: 51,
        onClose: () => {
          if (!this.languageChange) {
            this.changeMessageList(msgId);
          }
          if(!instance.closeAll){
            closeMessage(instance)
          }
        },
      });
    },

    readMessage(msgId, instance) {
      //  如果当前为空 ，表明当前没有消息要读   ，直接进入读消息状态
      let inboxDetailDialog = this.$store.state.config.inboxDetailDialog;
      if (!isEmpty(inboxDetailDialog) && inboxDetailDialog.show == false) {
        this.$store.dispatch("config/readMessage", {
          show: true,
          id: msgId,
        });
        if (instance) {
          instance.close();
        }
      } else {
        // 表明当前有正在阅读的消息    ，不可打开
        this.$notify.warning(this.$t("messageBoxPromptMessage.inReading"));
      }
    },

    changeMessageListLang() {
      closeAllMessage();
      this.messageList.forEach((item) => {
        setTimeout(() => this.dealMessageNotice(item.messageInfo), 0);
      });
      setTimeout(() => {
        this.languageChange = false;
      }, 0);
    },
    changeMessageList(msgId) {
      this.messageList = this.messageList.filter((item) => item.msgId != msgId);
    },
  },
};
</script>
<style lang="scss" scoped>
.message-container {
  display: flex;
  align-items: center;
  i {
    font-size: 18px;
    cursor: pointer;
  }
  ::v-deep .el-badge__content {
    height: 14px;
    font-size: 12px;
    line-height: 14px;
    padding: 0 3px;
    min-width: 8px;
    right: 8px;
  }
}
</style>
